<template>
    <div class="xshzDetail">
        <div class='ztbjX'>
            <div class='zbtitle'>
                <img class='titleImg' src="../../../assets/images/zbtitle.png" alt="">
            </div>

            <div class='zbcon'>
                <img @click='handleclickzg(njsbg._id, njsbg.qyCount)' class='njsb'
                    src="../../../assets/images/nzcpth5.png" alt="">
                <img @click='handleclickzg(spjgg._id, spjgg.qyCount)' class='spjg'
                    src="../../../assets/images/spjgh5.png" alt="">

                <img @click='handleclickzg(qyppg._id, qyppg.qyCount)' class='qypp'
                    src="../../../assets/images/nyfwth5.png" alt="">

                <img @click='handleclickzg(xczxg._id, xczxg.qyCount)' class='xczx'
                    src="../../../assets/images/nykjth5.png" alt="">

                <img @click='handleclickzg(zhnzg._id, zhnzg.qyCount)' class='zhny'
                    src="../../../assets/images/nyscth5.png" alt="">

                <img @click='handleclickzg(nhzpg._id, nhzpg.qyCount)' class='nhzp'
                    src="../../../assets/images/njzzth5.png" alt="">

            </div>

            <div class="zbbottom">
                <div class='bottomCon' style='margin-bottom:0.28rem'>云览名企 VR探场 优企联动</div>
                <div class='bottomCon'>即刻入馆 抢抓商机 18910514060</div>
            </div>
        </div>
    </div>

</template>
<script setup>
import { ref, getCurrentInstance, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

const props = defineProps({
    topHeight: {
        type: Number,
        default: 0
    }
})

const zhnzg = ref({})
const nhzpg = ref({})
const njsbg = ref({})
const spjgg = ref({})
const qyppg = ref({})
const xczxg = ref({})



const getListInfo = () => {
    proxy.$request({
        method: "post",
        url: "QPSTZX_SXYZG_SXYZGLIST",
        data: {

        },
    }).then((res) => {
        if (res.data.code == "000") {
            res.data.result.map((item) => {
                if (item.zgmc == '智慧农业馆' || item.zgmc == '农业生产厅') {
                    zhnzg.value = item
                }
                if (item.zgmc == '农化制品馆' || item.zgmc == '农机制造厅') {
                    nhzpg.value = item
                }
                if (item.zgmc == '农机设备馆' || item.zgmc == '农业化工厅') {
                    njsbg.value = item
                }
                if (item.zgmc == '食品加工馆' || item.zgmc == '食品加工厅') {
                    spjgg.value = item
                }
                if (item.zgmc == '区域品牌馆' || item.zgmc == '农业服务厅') {
                    qyppg.value = item
                }
                if (item.zgmc == '乡村振兴馆' || item.zgmc == '农业科技厅') {
                    xczxg.value = item
                }


            })
        }
    });
}
getListInfo()

const handleclickzg = (id, count) => {
    var numberCount = Number(count)
    console.log(numberCount)
    if (numberCount > 0) {
        router.push({
            path: '/h5/xshzDetails',
            query: {
                id: id
            }
        });
    }

}


</script>
<style lang="less" scoped>
.ztbjX {
    width: 100%;
    height: 100vh;
    background: url('../../../assets/images/ztbj.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 1.2rem;
    box-sizing: border-box;

    .zbtitle {
        width: 6rem;
        height: 2.88rem;
        margin: 0 auto;

        .titleImg {
            width: 6rem;
            height: 2.88rem;
        }
    }

    .zbcon {
        width: 100%;
        height: 5.6rem;
        background: url('../../../assets/images/zbcon.png') no-repeat;
        background-size: 100% 100%;
        position: relative;
        margin-top:1rem;

        // 背景图基准：假设设计稿基于 750px 宽度
        // 换算比例：1px = 100vw / 750
        .njsb {
            width: 1.6rem;
            height: 1.46rem;
            position: absolute;
            top: -20%;
            left: 40%;
        }

        .spjg {
            width: 1.6rem;
            height: 1.46rem;
            position: absolute;
            top: -7%;
            left: 8%;
        }

        .qypp {
            width: 1.6rem;
            height: 1.46rem;
            position: absolute;
            top: 36%;
            left: 4%;
        }

        .xczx {
            width: 1.6rem;
            height: 1.46rem;
            position: absolute;
            top: 52%;
            left: 42%;
        }

        .zhny {
            width: 1.6rem;
            height: 1.46rem;
            position: absolute;
            top: 35%;
            left: 77%;
        }

        .nhzp {
            width: 1.6rem;
            height: 1.46rem;
            position: absolute;
            top: -4%;
            left: 77%;
        }
    }

    .zbbottom {
        width: 100%;
        height: 3rem;
        background: url('../../../assets/images/zbbottom.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 1.6rem;
        box-sizing: border-box;

        .bottomCon {
            font-size: 36rpx;
            color: #FFFFFF;
            font-size: 0.36rem;
            font-weight: 900;
            margin: 0 auto;
            width: 100%;
            text-align: center;
        }

    }

}
</style>